import * as tslib_1 from "tslib";
import { CommandContainer } from './command_container';
var ButtonGroup = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonGroup, _super);
    function ButtonGroup(param) {
        return _super.call(this, param) || this;
    }
    ButtonGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ButtonGroup" });
    };
    ButtonGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ButtonGroup;
}(CommandContainer));
export { ButtonGroup };
//# sourceMappingURL=button_group.js.map